module.exports = __webpack_public_path__ + "img/seche_serviette.ea1ea8f.svg";